import React, { Component } from "react";
import axios from 'axios';
 
const AxieDetailRow = ({index, axie}) => (
	<tr>
	<td> {index+1}.</td>
	<td><img width="100px" src={axie.img}/></td>
	<td> <a target="_blank" href={`https://axieinfinity.com/axie/${axie.id}`} >{axie.id}</a></td>
	<td> {axie.name}</td>
	<td> {axie.level}</td>
	<td> {axie.totalExp}</td>
	<td> <a target="_blank" href={`https://axieinfinity.com/profile/${axie.owner}`} >{axie.owner}</a></td>
</tr>
)

class Tools extends Component {
	state = {
	    top_axies: []
	}

	componentDidMount(){
        const script = document.createElement("script");

        script.src = "/dist/js/position.js";

        document.body.appendChild(script);

        axios.get('https://coinmm.co/node/top_axie/30')
	      .then(res => {
	        const top_axies = res.data;
	        this.setState({ top_axies });
	    });
    }
  
    
 	render() {
		 const {top_axies} = this.state;
	    return (
	    	<div>
		        <div className="row">
			        <div className="col-md-12">
			            <div className="box box-default">
		                    <div className="box-header with-border">
		                        <h3 className="box-title">Position Distance Calculator</h3>
		                        <br></br>
		                        <p><i>Tips: Click on the * to see the distance to the enemy team on the right.<br></br>
		                        If both targets have the same distance the attacking will be random.</i></p>
		                    </div>
		                    <div className="box-body">
		                        <div id="container">
		                        </div>
		                    </div>
		                    <div className="overlay box_loading">
		                        <i className="fa fa-refresh fa-spin"></i>
		                    </div>
		                </div>
			        </div>
			    </div>
			    <div className="row">
			        <div className="col-md-12">
			            <div className="box box-default">
		                    <div className="box-header with-border">
		                        <h3 className="box-title">Top 30 Axies by Level & Total Exp</h3>
		                        <p><i>Tips: This chart update once daily at 12am UTC.</i></p>
		                    </div>
		                    <div className="box-body">
		                        <div id="top_axie_container">
		                        <table className="table table-bordered">
		                        	<thead>
			                        	<tr>
			                        		<th>#</th>
			                        		<th>Img</th>
			                        		<th>Id</th>
			                        		<th>Name</th>
			                        		<th>Level</th>
			                        		<th>Exp</th>
			                        		<th>Owner</th>
			                        	</tr>
		                        	</thead>
		                        	<tbody>
										  {top_axies.map((axie,index) =>
										  <AxieDetailRow axie={axie} index={index}/>
							        	// <tr>
							        	// 	<td> {index+1}.</td>
							        	// 	<td><img width="100px" src={axie.img}/></td>
							        	// 	<td> <a target="_blank" href={`https://axieinfinity.com/axie/${axie.id}`} >{axie.id}</a></td>
							        	// 	<td> {axie.name}</td>
							        	// 	<td> {axie.level}</td>
							        	// 	<td> {axie.totalExp}</td>
							        	// 	<td> <a target="_blank" href={`https://axieinfinity.com/profile/${axie.owner}`} >{axie.owner}</a></td>
							        	// </tr>
							          	)}
						          	</tbody>
						        </table>
		                        </div>
		                    </div>
		                    <div className="overlay box_loading">
		                        <i className="fa fa-refresh fa-spin"></i>
		                    </div>
		                </div>
			        </div>
			    </div>
	    	</div>
	    );
 	}
}
 
export default Tools;



// WEBPACK FOOTER //
// ./src/Tools.js